export const GOALS_CONTEXT_QP = 'wmShowGoals';
export const CONTRIBUTING_CONTEXT_QP = 'wmShowContrib';
export const PENDING_AND_PAUSED_CONTEXT_QP = 'wmShowPending';
export const ENTITY_KEY_QP = 'wmKey';
export const FINAL_SCREEN_KEY = 'updatesCompleted';

export const WRITING_MODE_LOCAL_STORAGE_KEY = 'writing-mode';
